import { createContext } from 'react';
import { UseDataQueryResult } from './model';

export const DataQueriesContext = createContext<UseDataQueryResult | undefined>(undefined);
